import React, { useEffect, useState } from 'react'
import { CardEventDashboard } from '../../../../components/Dashboard/CardEventDashboard'
import { NothingToShow } from '../../../../components/Dashboard/NothingToShow'
import { eventService } from '../../../../services/event.service'

export const AproveEvents = () => {
  const [fetch, setFetched] = useState(false)
  const [eventsToAprove, setEventsToAprove] = useState([])

  useEffect(() => {
    const getEvents = async () => {
      const events = await eventService.getAllEventsToAproved()
      setEventsToAprove(events)
    }
    getEvents()
  }, [fetch])
  return (
    <>
      <h1 className="mb-2 mb-md-0 text-primary">Eventos por aprobar</h1>
      <br />
      {/* Events */}
      <div className="container-fluid">
        <div className="row">
          {
            eventsToAprove.length === 0 && (<NothingToShow />)
          }
          {
            eventsToAprove
              .map((e, index) =>
                (
                <div
                  key={index}
                  className="col-12"
                >
                  <CardEventDashboard
                    {...e}
                    setFetched={setFetched}
                    fetch={fetch}
                    fromPublicados={0}
                    fromAprobados={1} />
                </div>
                ))
          }
        </div>
     </div>
    </>
  )
}
